import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";


export type FilterInput = {
    customer: string;
    name: string;
    username: string;
    email: string;
    createdAt: string;
    investorId: string;
    employeeId: string;
}

export type InputValues = {
  filterName: keyof FilterInput | "",
  operation: string,
  value: string | Date
};

interface FilterState {
    advisorFilter?: InputValues[];
    investorFilter?: InputValues[];
}

const initialState: FilterState = {
  advisorFilter: [],
  investorFilter: []
};

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    advisorFilter: (state, action: PayloadAction<InputValues[]>) => {
      state.advisorFilter = action.payload;
    },
    investorFilter: (state, action: PayloadAction<InputValues[]>) => {
      state.investorFilter = action.payload;
    },
  },
});

export const loggedInSelector = (state: RootState) => state.login.loggedIn;

export const { advisorFilter, investorFilter } = filterSlice.actions;

export default filterSlice.reducer;
